import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// const firebaseConfig = {
//   apiKey: "AIzaSyBgFxJjveDoU0_Ze2JpgBSsQSqfh7n6XH0",
//   authDomain: "promocoes-8a603.firebaseapp.com",
//   projectId: "promocoes-8a603",
//   storageBucket: "promocoes-8a603.firebasestorage.app",
//   messagingSenderId: "436068135350",
//   appId: "1:436068135350:web:386ac18bba2b6a2d00d117"
// };

const firebaseConfig = {
  apiKey: "AIzaSyCm5Lk1pTB_yQuWciV6Ts_6uFSVTs7d96w",
  authDomain: "zapdaspromos-34096.firebaseapp.com",
  projectId: "zapdaspromos-34096",
  storageBucket: "zapdaspromos-34096.firebasestorage.app",
  messagingSenderId: "542885416999",
  appId: "1:542885416999:web:0097fedc8ebb14577c7e02"
};


const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };

